import { render, staticRenderFns } from "./ObjectLinkValue.vue?vue&type=template&id=025952a9&"
import script from "./ObjectLinkValue.vue?vue&type=script&lang=js&"
export * from "./ObjectLinkValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports